import { Galleria, GalleriaItemChangeEvent } from "primereact/galleria";
import { ReactElement, useState } from "react";
import { PhotoData } from "../../types/PhotoData";
import { GetPhotosResponse } from "../../types/GetPhotosResponse";
import React from "react";
import { DocumentResponse } from "../../types/DocumentResponse";
import { ImageAlbumGalleryComponent } from "../ImageAlbumGallery/ImageAlbumGallery";
import "./VesselGallery.css";

export const VesselGallery = (props: {
    autoOpen?: boolean;
    photoData: GetPhotosResponse[];
    documentData?: DocumentResponse;
    section?: string | null;
    restrictedView?: boolean;
    earlyRelease?: boolean;
    downloadCallback?: () => void;
}): ReactElement => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const photoTemplate = (item: PhotoData) => {
        return <img src={`${item}`} className="block w-full image-rounded" />;
    };

    const galleryComponent = () => {
        return ImageAlbumGalleryComponent(
            props?.autoOpen ? true : false,
            props?.photoData,
            props?.documentData,
            props.restrictedView,
            props?.section ? props?.section : undefined,
            "absolute bottom-0 mr-2 mb-2 right-0 z-5",
            undefined,
            props.earlyRelease,
            props.downloadCallback
        );
    };

    const mainPhotoAlbum: GetPhotosResponse = props?.photoData.filter(
        (album) => album.isDefault
    )[0];

    mainPhotoAlbum.images?.unshift(mainPhotoAlbum.frontImage);
    const mainPhotos = Array.from(new Set(mainPhotoAlbum.images));
    const multipleImages = mainPhotos && mainPhotos?.length > 1;

    if (!multipleImages) {
        return (
            <div className="gallery-item">
                {galleryComponent()}
                <img
                    src={`${mainPhotos?.[0]}`}
                    className="block w-full image-rounded"
                />
            </div>
        );
    }

    const handleNextImage = (e: GalleriaItemChangeEvent) => {
        setActiveIndex(e.index);
    };

    return (
        <div className="gallery-item">
            {galleryComponent()}
            <Galleria
                value={mainPhotos}
                numVisible={5}
                circular
                style={{ maxWidth: "800px" }}
                showItemNavigators
                showItemNavigatorsOnHover
                showThumbnails={false}
                activeIndex={activeIndex}
                onItemChange={(e) => handleNextImage(e)}
                item={photoTemplate}
            />
        </div>
    );
};
